import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  Image,
  mobileOnlyLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const DOLInfoBody = ({
  showItemNumberArrow,
  showTrackingNumberArrow,
  isMobile,
}: {
  showTrackingNumberArrow?: boolean;
  showItemNumberArrow?: boolean;
  isMobile?: boolean;
}) => {
  const {t} = useTranslation();
  return (
    <BodyWrapper>
      <AddressWrapper>
        <Address>
          <span>{t('Delivery adress')}</span>
          <span>Anna Spencer</span>
          <span>10117 Berlin</span>
        </Address>
        <Address>
          <span>{t('Billing adress')}</span>
          <span>Anna Spencer</span>
          <span>10117 Berlin</span>
        </Address>
      </AddressWrapper>
      <YourOrderWrapper>
        <span>{t('Your order:')}</span>

        <YourOrderMainContentWrapper>
          <TrackingNumberIconWrapper>
            {showTrackingNumberArrow && (
              <TrackingNumberIcon
                asset={GenericIconName.ArrowLongRight}
                size="S"
                color="black"
              />
            )}
          </TrackingNumberIconWrapper>

          <OrderIdWrapper data-is-hidden={!showTrackingNumberArrow}>
            {t('TRACKING NUMBER XXXXXXXXXXXXXXXXXXXX')}
          </OrderIdWrapper>
        </YourOrderMainContentWrapper>
      </YourOrderWrapper>

      {!isMobile && (
        <ExpectedDeliveryWrapper>
          {t('Expected delivery date: Tue 20.10 - Wed 23.10')}
        </ExpectedDeliveryWrapper>
      )}

      <ItemWrapper>
        <ImageWrapper>
          <Image
            ratio={'1:1.2'}
            breakpoints={[]}
            src="https://cdn.aboutstatic.com/file/images/6473cbe3b3867fc925dc735e45bf9ca2.jpg?brightness=0.96&quality=75&trim=1&height=100&width=90"
          />
        </ImageWrapper>
        <ProductInfoWrapper>
          <span>ABOUT YOU</span>
          <span>{t('Brown Jacket')}</span>
          <span>{t('Amount: 1')}</span>
          <span>{t('Color: Brown')}</span>
          <span>{t('Size: M')}</span>

          <ItemNumberWrapper>
            <span>{t('Article no.: XXXXXX-XX')}</span>
            <ItemNumberIconWrapper>
              {showItemNumberArrow && (
                <ItemNumberIcon
                  asset={GenericIconName.ArrowLongRight}
                  size="S"
                  color="black"
                  $isMobile={isMobile}
                />
              )}
            </ItemNumberIconWrapper>
          </ItemNumberWrapper>
        </ProductInfoWrapper>

        <StatusWrapper>{t('Shipped')}</StatusWrapper>
      </ItemWrapper>
    </BodyWrapper>
  );
};

const Address = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 45%;
  span {
    font-size: ${FONT_SIZES.px12};
    line-height: 18px;
  }

  span:first-child {
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    border-bottom: 1px solid ${COLORS.Grey3};
  }
`;

const AddressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
`;

const ItemNumberWrapper = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;
const ItemNumberIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const YourOrderWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  gap: 15px;
  align-items: center;
  justify-content: space-between;

  span {
    white-space: nowrap;
  }
`;

const OrderIdWrapper = styled.div`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 18px;
  background-color: ${COLORS['Alerts.Success.Primary']};
  padding: 4px 8px;
  color: ${COLORS.White};
  text-align: center;

  &[data-is-hidden='true'] {
    visibility: hidden;
  }

  ${mobileOnlyLinaria(`
    word-break: break-word;
`)}
`;

const YourOrderMainContentWrapper = styled.div`
  display: flex;
  gap: 15px;
`;

const ExpectedDeliveryWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.Grey4};
  padding: 8px 10px;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 18px;
`;

const ItemWrapper = styled.div`
  display: flex;
  padding: 16px 0;
`;

const ImageWrapper = styled.div`
  height: 100px;
  width: 90px;
  padding: 16px;
`;
const ProductInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  padding-left: 16px;

  & span {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    line-height: 18px;
    color: ${COLORS.Grey1};
  }

  & span:nth-child(2),
  span:first-child {
    color: ${COLORS.Black};
  }
`;
const StatusWrapper = styled.div`
  color: ${COLORS['Alerts.Success.Primary']};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  flex: 1;
  display: flex;
  align-items: right;
  justify-content: right;
  padding-right: 16px;
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  pointer-events: none;
`;

const TrackingNumberIcon = styled(Icon)`
  @keyframes backAndForthAnimation {
    0% {
      transform: translate(0);
    }
    50% {
      transform: translateX(15px);
    }
    100% {
      transform: translateX(0);
    }
  }

  position: absolute;
  right: 0px;
  animation-name: backAndForthAnimation;
  animation-duration: 1.5s;
  transition-timing-function: ease-in-out;
  animation-iteration-count: infinite;
`;

const TrackingNumberIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 30px;
`;

const ItemNumberIcon = styled(Icon)<{$isMobile?: boolean}>`
  @keyframes backAndForthAnimationWithRotate {
    0% {
      transform: translate(0) rotate(180deg);
    }
    50% {
      transform: translate(-15px) rotate(180deg);
    }
    100% {
      transform: translate(0) rotate(180deg);
    }
  }

  position: absolute;
  left: 0px;
  animation-name: backAndForthAnimationWithRotate;
  animation-duration: 1.5s;
  transition-timing-function: ease-in-out;
  animation-iteration-count: infinite;
`;
